import { useEffect, useState } from 'react';
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '@/utils/i18n';
import { APP_LANGUAGES } from '@/utils/languages';

/**
 * Language picker used on the Settings page. Switching calls the shared
 * `setLanguage` helper so i18next, `document.dir` (RTL for Arabic), and the
 * persisted `localStorage` choice stay in sync.
 */
export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(i18n.resolvedLanguage ?? i18n.language);

  useEffect(() => {
    const sync = (lng: string) => setValue(lng);
    i18n.on('languageChanged', sync);
    return () => {
      i18n.off('languageChanged', sync);
    };
  }, [i18n]);

  return (
    <IonItem>
      <IonSelect
        label={t('settings.language')}
        interface="popover"
        value={value}
        data-testid="language-select"
        onIonChange={(event) => void setLanguage(event.detail.value as string)}
      >
        {APP_LANGUAGES.map((lang) => (
          <IonSelectOption key={lang.code} value={lang.code}>
            <IonLabel>
              {lang.label} · {lang.englishLabel}
            </IonLabel>
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
}
